import { translatableZodSchema } from "@@/shared/translations/translation";
import type { Except } from "type-fest";
import { z } from "zod";

const agendaFilterZodObject = z.union([
    z.object({
        label: translatableZodSchema,
        value: z.string(),
        type: z.enum([
            "product",
            "resource",
            "order-status",
            "order-type",
            "order-source",
            "order-group-reference",
            "order-id",
            "payment-status",
            "text",
        ]),
    }),
    z.object({
        label: translatableZodSchema,
        value: z.boolean(),
        type: z.enum(["unpaid", "with_comments"]),
    }),
]);

type AgendaFilter = z.infer<typeof agendaFilterZodObject>;
type AgendaFilter_Translated = Except<AgendaFilter, "label"> & {
    label: string;
};

export { agendaFilterZodObject };
export type { AgendaFilter, AgendaFilter_Translated };
